'use strict';

require("./ReportsController");